import { useState, useEffect, useCallback } from 'react';
import { weatherApi } from '../services/weatherApi';

export const useWeather = (latitude, longitude) => {
  const [weather, setWeather] = useState(null);
  const [airQuality, setAirQuality] = useState(null);
  const [pollen, setPollen] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchWeatherData = useCallback(async (lat, lon) => {
    if (!lat || !lon) return;

    setLoading(true);
    setError(null);

    try {
      const [weatherData, airQualityData, pollenData] = await Promise.all([
        weatherApi.getCurrentWeather(lat, lon),
        weatherApi.getAirQuality(lat, lon),
        weatherApi.getPollenData(lat, lon)
      ]);

      setWeather(weatherData);
      setAirQuality(airQualityData);
      setPollen(pollenData);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchWeatherData(latitude, longitude);
  }, [latitude, longitude, fetchWeatherData]);

  return {
    weather,
    airQuality,
    pollen,
    loading,
    error,
    refetch: () => fetchWeatherData(latitude, longitude)
  };
};
